export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10694.f37eeda7.jpg";